import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class DatasharingService {
  isVisibleSource: BehaviorSubject<string> = new BehaviorSubject<string>("default value");
  

  constructor() { }
 
}
